import { useContext } from 'react';
import ConfigurationContext from './configuration-context.js';

const useConfiguration = () => {
	return useContext(ConfigurationContext);
};

export default useConfiguration;
